module.exports = __webpack_public_path__ + "static/exam-487-developing-microsoft-azure-and-web-services-81a18525a7bf0b518181bb6bf9bc5d45.png";